import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FormConfiguration } from "pax-ui/components";
import { Emoji } from "projects/pax-ui/components/emoji/emoji-alt-mapping";
import { filter, map, tap } from "rxjs";
import { FormName } from "src/app/shared/models/form-name";

import { BasePage, PremiumFormModel } from "../base/base.page";
import { CheckoutPage } from "../checkout-page/checkout-page";

@UntilDestroy()
@Component({
  selector: "app-date-of-birth",
  imports: [CommonModule, CheckoutPage],
  templateUrl: "../base/base.page.html",
  styleUrls: ["../base/base.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateOfBirthPage extends BasePage implements OnInit {
  public override emojis: Emoji[] = ["🎂"];

  public override infoDialog = {
    buttonLabel: $localize`Warum ist das wichtig?`,
    title: this.productSpecificCustomRouteData.infoDialog?.title ?? "",
    contentAsMarkdown:
      this.productSpecificCustomRouteData.infoDialog?.contentAsMarkdown ?? "",
  };

  public override formConfiguration: FormConfiguration =
    this.getFormConfiguration(undefined, undefined);

  private getFormConfiguration(
    minimumEntryAge: number | undefined,
    maximumEntryAge: number | undefined,
  ) {
    const formConfiguration: FormConfiguration = {
      name: FormName.DATE_OF_BIRTH,
      rows: [
        this.formComponentService.getDateOfBirthRow(
          minimumEntryAge,
          maximumEntryAge,
          "flex justify-center",
        ),
      ],
    };

    return formConfiguration;
  }

  ngOnInit() {
    super.initialize(this.formConfiguration);
    this.loadEntryAgeConstraints();
    this.data$ = this.loadFormValuesFromStoreObservable();
  }

  private loadFormValuesFromStoreObservable() {
    return this.quoteStoreFacade
      .getDateOfBirthPageState(this.productSpecificCustomRouteData.product)
      .pipe(
        untilDestroyed(this),
        filter(() => !this.hasBeenSubmitted),
        map((dateOfBirthPageState) => {
          const premiumForm: PremiumFormModel = {
            dateOfBirth: dateOfBirthPageState.dateOfBirth,
          };
          return premiumForm;
        }),
      );
  }

  private loadEntryAgeConstraints() {
    this.productConstraintsFacade
      .getEntryAgeConstraints(this.productSpecificCustomRouteData.product)
      .pipe(
        untilDestroyed(this),
        filter(() => !this.hasBeenSubmitted),
        tap((entryAgeConstraints) => {
          this.formConfiguration = this.getFormConfiguration(
            entryAgeConstraints.min,
            entryAgeConstraints.max,
          );
        }),
      )
      .subscribe();
  }
}
